import Container from './TierSidebarCard.container';
import TierSidebarCard from './TierSidebarCard';

export default Container(TierSidebarCard);
